import React, { Component } from 'react'
import i18n from '../i18n'
import httpRequest from '../components/request-api'
import moment from 'moment'
import { withNamespaces } from 'react-i18next'

class NewsDetail extends Component {
  constructor(props) {
    super(props);
    this.changeLanguage(this.props.match.params.lang)
    this.state= {
      news:[],
      popular:[],
      preload: false
    }
  }

  changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  }

  renderNewsPopular = async () => {
    await httpRequest.newsPopular().then(result => {
      this.setState({
        popular : result.data.result
      })
    }).catch(error => {
        console.log(error);
    })
  } 

  componentDidMount() {
    this.renderNews(this.props.match.params.id)
    this.renderNewsPopular()
  }

  renderNews = async (id) => {
    window.scrollTo({top: 0, behavior: 'smooth'});
    this.setState({
      preload: true
    })
    await httpRequest.newsDetail(id).then(result => {
      this.setState({
        news : result.data.result
      })
    }).catch(error => {
      this.setState({
        preload: false
      })
        console.log(error);
    })
  }

  render() {
    const handleClick = (id) => {
      this.renderNews(id)
    }

    const {news, popular} = this.state
    const { t } = this.props;

    return (
      <div id="app">
        <main>
          <section className="blog_area single-post-area section-padding pt-0">
            <div className="container">
              <div className="row">
                <div className="col-lg-8 posts-list">
                  <div className="single-post">
                    <div className="feature-img">
                        <img src={`${news.image_url}`} width="100%" alt="post" />
                    </div>
                    <div className="blog_details">
                      <h2>{news.topic}
                      </h2>
                      <div dangerouslySetInnerHTML={{ __html: news.content }} />
                    </div>
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="blog_right_sidebar">
                    <aside className="single_sidebar_widget popular_post_widget">
                      <h3 className="widget_title">{t('latestNews')}</h3>
                      {
                        popular.map((item, i)=>(
                          <div className="media post_item" key={i}>
                            <img src={`${item.image_url}/128`} alt="post" />
                            <div className="media-body">
                              <a href="#" onClick={() => handleClick(item.id)}>
                                <span style={{cursor:"pointer"}}>{item.topic}</span>
                              </a>
                              <p><small>{moment(item.publish_date).format('LL')}</small></p>
                          </div>
                          </div>
                        ))
                      }
                    </aside>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </main>
      </div>
    );
  }
}

export default withNamespaces()(NewsDetail);
